import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right-white",
  "use": "icon-chevron-right-white-usage",
  "viewBox": "0 0 16.366 30.991",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.366 30.991\" id=\"icon-chevron-right-white\">\n  <path id=\"icon-chevron-right-white_np_chevron_933251_000000\" d=\"M50.209,34.9l-1.124-1.314L36.93,19.406l-3.086,2.627L44.875,34.9,33.843,47.77,36.93,50.4,49.086,36.215Z\" transform=\"translate(-33.843 -19.406)\" fill=\"#d7d7d7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-right-white.svg
// module id = 118
// module chunks = 0 1 2